"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NormalParameter = void 0;
const string_normalizer_1 = require("../../util/string-normalizer");
const suggester_1 = require("../suggester");
const parameter_1 = require("./parameter");
class NormalParameter extends parameter_1.Parameter {
    constructor(text, mode, type, language, ignoreOptions) {
        super();
        this.text = text;
        this.mode = mode;
        this.type = type;
        this.language = language;
        this.ignoreOptions = ignoreOptions === "default" ? this.getDefaultIgnoreOptions() : ignoreOptions;
    }
    static createEmpty(language) {
        const parameter = new NormalParameter("", "both", "prefix", language, { case: false, diacritic: false, space: true, wave: true });
        return parameter;
    }
    match(word) {
        const candidates = parameter_1.Parameter.createCandidates(word, this.mode, this.language);
        const matcher = parameter_1.Parameter.createMatcher(this.type);
        const normalizedText = string_normalizer_1.StringNormalizer.normalize(this.text, this.ignoreOptions);
        const predicate = candidates.some((candidate) => {
            const normalizedCandidate = string_normalizer_1.StringNormalizer.normalize(candidate, this.ignoreOptions);
            return matcher(normalizedText, normalizedCandidate);
        });
        return predicate;
    }
    getDefaultIgnoreOptions() {
        const mode = this.mode;
        const type = this.type;
        if ((mode === "name" || mode === "both") && (type !== "pair" && type !== "regular")) {
            return { case: false, diacritic: true, space: true, wave: true };
        }
        else {
            return { case: false, diacritic: false, space: true, wave: true };
        }
    }
    createSuggesters(dictionary) {
        const mode = this.mode;
        const type = this.type;
        const suggesters = [];
        if ((mode === "name" || mode === "both") && (type === "exact" || type === "prefix")) {
            const revisionSuggester = new suggester_1.RevisionSuggester(this.text, this.ignoreOptions);
            const inflectionSuggester = suggester_1.InflectionSuggesterCreator.createByVersion(dictionary.settings.version, this.text, this.ignoreOptions);
            suggesters.push(revisionSuggester);
            if (inflectionSuggester !== undefined) {
                suggesters.push(inflectionSuggester);
            }
        }
        return suggesters;
    }
}
exports.NormalParameter = NormalParameter;
